module.exports = __webpack_public_path__ + "img/logo_televet.2f90c28f.png";